module.exports = __webpack_public_path__ + "static/mysql-4b0af24753e00cc3f9508ddb5d8ab3be.png";